enum MovieListActionType {
  FETCH_MOVIE_LIST_REQUEST = 'FETCH_MOVIE_LIST_REQUEST',
  FETCH_MOVIE_LIST_REQUEST_SUCCESS = 'FETCH_MOVIE_LIST_REQUEST_SUCCESS',
  FETCH_MOVIE_LIST_REQUEST_ERROR = 'FETCH_MOVIE_LIST_REQUEST_ERROR',

  FETCH_TRENDING_MOVIE_LIST_REQUEST = 'FETCH_TRENDING_MOVIE_LIST_REQUEST',
  FETCH_TRENDING_MOVIE_LIST_REQUEST_SUCCESS = 'FETCH_TRENDING_MOVIE_LIST_REQUEST_SUCCESS',
  FETCH_TRENDING_MOVIE_LIST_REQUEST_ERROR = 'FETCH_TRENDING_MOVIE_LIST_REQUEST_ERROR',

  FETCH_SIMILAR_MOVIE_LIST_REQUEST = 'FETCH_SIMILAR_MOVIE_LIST_REQUEST',
  FETCH_SIMILAR_MOVIE_LIST_REQUEST_SUCCESS = 'FETCH_SIMILAR_MOVIE_LIST_REQUEST_SUCCESS',
  FETCH_SIMILAR_MOVIE_LIST_REQUEST_ERROR = 'FETCH_SIMILAR_MOVIE_LIST_REQUEST_ERROR',

  UPDATE_LIKE_MOVIE_LIST_REQUEST = 'UPDATE_LIKE_MOVIE_LIST_REQUEST',
}

export default MovieListActionType
